<template>
    <v-container fluid tag="section" class="users">
        <v-row justify="start">
            <v-dialog v-model="dialog" persistent max-width="440">
                <template v-slot:activator="{ on }">
                    <v-btn class="display-1" color="primary" dark v-on="on">Добавить</v-btn>
                </template>
                <v-card>
                    <v-card-title class="headline">
                        Добавить пользователя
                        <v-btn
                            color="green darken-1"
                            text
                            class="close-btn"
                            @click="dialog = false"
                        >
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <form>
                            <!-- Фамилия -->
                            <v-col cols="12" class="pb-0">
                                <v-text-field
                                    v-model="formData.last_name"
                                    v-validate="'required|alpha_dash'"
                                    :error-messages="errors.collect('last_name')"
                                    label="* Фамилия"
                                    data-vv-name="last_name"
                                    validate-on-blur
                                    required
                                    color="purple darken-2"
                                    clearable
                                    prepend-icon="mdi-account-edit"
                                />
                            </v-col>

                            <!-- ИМЯ -->
                            <v-col cols="12" class="py-0">
                                <v-row>
                                    <v-col cols="12" class="py-0">
                                        <v-text-field
                                            v-model="formData.first_name"
                                            v-validate="'required|alpha_dash'"
                                            :error-messages="errors.collect('first_name')"
                                            label="* Имя"
                                            data-vv-name="first_name"
                                            validate-on-blur
                                            required
                                            color="purple darken-2"
                                            clearable
                                            prepend-icon="mdi-account-edit"
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                            <!-- Отчество -->
                            <v-col cols="12" class="py-0">
                                <v-row>
                                    <v-col cols="12" class="py-0">
                                        <v-text-field
                                            v-model="formData.middle_name"
                                            label="Отчество"
                                            data-vv-name="middle_name"
                                            color="purple darken-2"
                                            clearable
                                            prepend-icon="mdi-account-edit"
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>

                            <!-- ТЕЛЕФОН -->
                            <v-col cols="12" class="py-0">
                                <v-row>
                                    <v-col cols="12" class="py-0">
                                        <v-text-field
                                            v-model="formData.phone_number"
                                            v-validate="'required|min:12'"
                                            v-mask="mask"
                                            prepend-icon="mdi-phone"
                                            type="text"
                                            :error-messages="errors.collect('phone_number')"
                                            label="* Номер телефона"
                                            color="purple darken-2"
                                            data-vv-name="phone_number"
                                            class="input-group--focused"
                                            required
                                            hint="введите номер в формате +38... или +7..."
                                            validate-on-blur
                                            clearable
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>

                            <!-- Email -->
                            <v-col cols="12" class="py-0">
                                <v-text-field
                                    v-model="formData.email"
                                    v-validate="'required|email'"
                                    :error-messages="errors.collect('email')"
                                    label="* E-mail"
                                    color="purple darken-2"
                                    data-vv-name="email"
                                    prepend-icon="mdi-email"
                                    clearable
                                    validate-on-blur
                                    required
                                />
                            </v-col>
                            <v-col cols="12" class="py-0 mt-4 text-center">
                                <v-btn
                                    class="mr-0"
                                    color="#0051ff"
                                    @click="submit"
                                    :disabled="disabledSubmitButton"
                                >Отправить приглашение</v-btn>
                            </v-col>
                        </form>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
    import { mask } from "vue-the-mask";

    export default {
        $_veeValidate: {
            validator: "new"
        },
        name: "ModalUser",
        directives: {
            mask
        },
        data: vm => ({
            dialog: '',
            formData: {
                last_name: '',
                first_name: '',
                middle_name: '',
                email: '',
                phone_number: '',
            },
            menu: '',

            dictionary: {
                attributes: {
                    email: "E-mail Address"
                    // custom attributes
                },
                custom: {
                    first_name: {
                        required: () => "Введите имя",
                        alpha_dash: "Неверный ввод"
                    },
                    last_name: {
                        required: () => "Введите фамилию",
                        alpha_dash: "Неверный ввод"
                    },
                    middle_name: {
                        alpha: "Только буквы"
                    },
                    email: {
                        required: "Введите email",
                        email: "Невалидный email"
                    },
                    phone_number: {
                        required: "Введите номер",
                        min: "Минимум 12 символов"
                    },
                }
            },

            mask: "+############",
            value: "+",
            snackbar: false,
            snackbarColor: "success",
            disabledSubmitButton: false
        }),

        mounted() {
            this.$validator.localize("en", this.dictionary);
        },

        methods: {
            async submit() {
                const isValid = await this.$validator.validate();
                if (!isValid) {
                    return;
                }
                this.disabledSubmitButton = true;
                this.createProfile();
                this.clear();
                this.disabledSubmitButton = false;
            },
            createProfile() {
                this.$store.dispatch('users/createUserProfile', Object.assign({}, this.formData))
            },
            clear() {
                this.formData.last_name = '';
                this.formData.first_name = '';
                this.formData.middle_name = '';
                this.formData.email = '';
                this.formData.phone_number = '';
                this.$validator.reset();
            }
        }
    };
</script>

<style lang="scss" scoped>
    .companies {
        .dot {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            margin-right: 5px;
            background-color: green;
        }
        &-wrapper {
            max-height: 250px;
            .companies-card {
                display: flex;
                justify-content: center;
                .v-card-profile.v-card {
                    width: 100%;
                }
            }
        }
    }
</style>